import { render, staticRenderFns } from "./FormatPagePropertyEditTool.vue?vue&type=template&id=6a2caa26&scoped=true&"
import script from "./FormatPagePropertyEditTool.vue?vue&type=script&lang=ts&"
export * from "./FormatPagePropertyEditTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatPagePropertyEditTool.vue?vue&type=style&index=0&id=6a2caa26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2caa26",
  null
  
)

export default component.exports